import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { _throw } from "rxjs/observable/throw";
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import { Globals } from '../../globals';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private _Globals: Globals
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        console.log('HttpErrorInterceptor');

        return next.handle(req)
            .catch(error => {
                let serviceName: any = req.url.split('/');
                let serviceType = serviceName[3].split('.')[0];
                serviceName = serviceName[serviceName.length - 1]; // "GetAnnouncementt?announcementId=25"
                serviceName = serviceName.split('?')[0];


                switch (serviceName) {

                    case 'SaveAssessmentAnswer':
                    case 'SaveAssessmentAnswerForTest':

                        if (error instanceof HttpErrorResponse && error.status === 400) {
                            this._Globals._Toastr.error("We are sorry. An error happened while trying to save the answer. If the problem persists please contact iPEC support team.", "ELI");
                            /*enabling only answers buttons*/
                            $(".buttons label").removeClass("disabled");
                            $(".takingAssessment input").prop("disabled", false);
                            /*remove the selected answer*/
                            $(".buttons label").removeClass("active");
                            $('.buttons i.fa.fa-spinner.fa-pulse.fa-3x.fa-fw').hide();
                            localStorage.setItem("ELIResponseError", "1");

                            this.saveAtLog(serviceName, req, error.message);

                            return new EmptyObservable();
                        }
                        else
                            return _throw(error);

                    case 'SaveAssessmentAssignment':
                        if (error instanceof HttpErrorResponse && error.status === 400) {
                            this._Globals._Toastr.error("We are sorry.  An error happened when communicating with the ELI server.", "ELI");
                            localStorage.setItem("ELIResponseError", "1");
                            this.saveAtLog(serviceName, req, 'Http 400 Error');

                            return new EmptyObservable();
                        }
                        break;

                    default:
                        if (req.url.indexOf('AdminService.svc/SP9') !== -1) {
                            return _throw(error);;
                        }

                        this.saveAtLog(serviceName, req, JSON.stringify(error));
                        return _throw(error);
                }

                //return _throw(error);
                
            });

        //return next.handle(req).pipe(
        //    catchError((err: HttpErrorResponse) => {

        //        let serviceName: any = req.url.split('/');
        //        serviceName = serviceName[serviceName.length - 1];
                
        //        switch (serviceName) {
        //            case 'SaveAssessmentAnswer':
        //                if (err.status === 400) {
        //                    this._toastr.error("We ae sorry. An error happened while trying to save the answer. If the problem persists please contact iPEC support team.", "ELI");
        //                }
        //                break;
        //        }

        //        return _throw(err);

        //    })
        //);
    }

    saveAtLog(serviceName: AnalyserOptions, req: HttpRequest<any>, message: string) {

        console.log('request', req);

        let params = '';

        if (req.method == "GET") {
            params = req.url.split('?')[1];
        } else {
            params = req.body;
        }

        let data = {
            'he3': isNaN(this._Globals.getUserId()) ? 0 : this._Globals.getUserId(),
            'bo7': serviceName, //req.url,
            'pm5': message,
            'my6': btoa(params + ',' + encodeURIComponent(window.navigator.userAgent))
        }

        //this._Globals.clearAllAndRediretToLogin();

        this._Globals.postSaveAtLog(this._Globals._CryptoJs.encrypt(JSON.stringify(data), '7s6v9y$B&E)M@MxQfTjWnZq4t7x@z%C*')).subscribe((_data: any) => {
            console.log('response_postSaveAtLog', _data);
            this._Globals.validationToken(_data.result.Result);
        });
    }
}